import gsap from 'gsap'
import barba from '@barba/core'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Navigation } from './navigation'
import { initLenis, scrollToStart, parallax } from './lenis'
import { initAlpine } from './alpine'
import { initLoader } from './loader'
import { initAnimations } from './animation'
import { initPinMenus } from './menu-pin'
import { initSplitType } from './splitType'
import { initGallery } from './gallery'
import { initSwiper } from './swiper'
import { pinBannerLogo } from './banner'
import { initEventsPin } from './events'
import { initCursor, cursorEvents } from './cursor'
import { initMenuViewport } from './menu-viewport'
import { resdiary } from './resdiary'
import { newsletter } from './newsletter'
import { initEventbrite } from './eventbrite'

const initBarba = () => {
	window.initialLoad = true

	const nav = new Navigation()

	const initComponents = () => {
		parallax()
		initSplitType()
		initLoader()
		initAnimations()
		initGallery()
		initSwiper()
		initPinMenus()
		initEventsPin()
		pinBannerLogo()
		initMenuViewport()
		resdiary()
		cursorEvents()
		initEventbrite()
	}

	barba.init({
		debug: true,
		timeout: 10000,
		prevent: ({ href }) => href.includes('voucher'),
		schema: {
			prefix: 'data-load'
		},
		transitions: [
			{
				name: 'basic-transition',
				once(data) { },
				leave(data) {
					nav.closeNavigation()
					return gsap.to(data.current.container, {
						opacity: 0,
						duration: 0.4
					})
				},
				afterLeave() {
					scrollToStart()
					nav.setActiveState()
					ScrollTrigger.getAll().forEach(t => t.kill())
				},
				after(data) {
					return gsap.from(data.next.container, {
						opacity: 0,
						duration: 0.4
					})
				}
			}
		]
	})

	barba.hooks.once((data) => {
		initLenis()
		initAlpine()
		initCursor()
		newsletter()
		initComponents()

		window.onload = function () {
			window.initialLoad = false
			document.documentElement.classList.add('is-ready')
		}
	})

	barba.hooks.after((data) => {
		initComponents()

		const focusableElement = data.next.container.querySelector('h1, [tabindex="0"]')
		if (focusableElement) focusableElement.focus()
	})
}

export default initBarba